import styled from 'styled-components';
import { motion } from 'framer-motion';

const SectionTitle = styled(motion.h2)`
  font-family: 'Fraunces', 'Times New Roman', Georgia, serif;
  font-weight: 500;
  font-size: clamp(32px, 4vw, 48px);
  letter-spacing: -0.03em;
  line-height: 1.05;
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: center;
  margin-bottom: 56px;
  position: relative;
  display: inline-block;
  width: 100%;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    bottom: -16px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 2px;
    background: #FF5B3A;
    border-radius: 1px;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 40px;

    &::after {
      bottom: -12px;
    }
  }
`;

SectionTitle.defaultProps = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
  viewport: { once: true },
};

export default SectionTitle;
